import React from 'react';
import LoginForm from 'app/javascript/components/auth/LoginForm';

type Props = {
  sessionPath: string;
  passwordPath: string;
  emailLabel: string;
  passwordLabel: string;
  errorMessage?: string | null;
};

// データフェッチが無いため QueryClientProvider は置かない
const ShopsSessionsNew = (props: Props): React.ReactNode => (
  <LoginForm
    resourceName="shop"
    brand="TABETE 店舗管理画面"
    title="ログイン"
    supportMessage="お困りの場合は、画面右下のチャット、またはメールにて運営までお問い合わせください。"
    footer="© 株式会社コークッキング — TABETE"
    {...props}
  />
);

export default ShopsSessionsNew;
